module.exports = __webpack_public_path__ + "static/32DCAF_1_0-5e177ae9a28eaf8716ba80c8226967d2.woff";